import { ChevronLeft } from "lucide-react"
import { useLocation } from "wouter";

const PrivacyPolicyPage = () => {
  const [, navigate] = useLocation();
  
  return (
    <div className="min-h-auto bg-[#18181B]">
      <div className="max-w-4xl mx-auto px-4 py-10 pt-0 text-[#ffffff] space-y-6 terms-section privacy-policy">
      <div
					role="banner"
					className="flex justify-start items-center py-3 gap-2 sticky bg-[#18181B] top-0"
				>
					<button
						type="button"
						aria-label="Go back"
						onClick={() => navigate('/account')}
						className="h-8 w-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
					>
						<ChevronLeft className='h-[22px] w-[22px] text-[#ffffff]'/>
					</button>

					<h1 className="text-base font-semibold tracking-wide">
            Privacy Policy
					</h1>
				</div>
      <section className="!mt-[4px]">
        <h2 className="text-2xl font-semibold mt-8 mb-4">
          1. About this Policy
        </h2>
        <p className="mb-3">
          <span className="font-medium">1.1. </span> This policy explains when
          and why we collect personal information about our users, how we use
          it, and how we keep it secure, and your rights in relation to it.
        </p>
        <p className="mb-3">
          <span className="font-medium">1.2. </span> We may collect, use, and
          store your personal data, as described in this Privacy Policy and as
          described when we collect data from you.
        </p>
        <p className="">
          <span className="font-medium">1.3. </span> We are committed to
          complying with the General Data Protection Regulation (GDPR), as well
          as all other applicable international, federal, state, and local data
          protection and privacy laws, when handling your personal information.
          For the purposes of the GDPR, the SECH project will be the
          “controller” of all personal data we hold about you.
        </p>
      </section>

      <section>
        <h2 className="">2. Who are we?</h2>
        <p>
          We are SECH. We can be contacted at{' '}
          privacy@sech.io
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-6">
          3. What information we collect and why
        </h2>

        <div className="overflow-x-auto rounded-[4px]">
          <table className="min-w-full border border-[#4C4C4C]">
            <thead className="bg-[#3C3C3C] text-[#ffffff]">
              <tr>
                <th className="px-4 py-3 border border-[#4C4C4C] text-left">
                  Which information
                </th>
                <th className="px-4 py-3 border border-[#4C4C4C] text-left">
                  What we do
                </th>
                <th className="px-4 py-3 border border-[#4C4C4C] text-left">
                  Why we do it
                </th>
                <th className="px-4 py-3 border border-[#4C4C4C] text-left">
                  How long do we keep your information
                </th>
              </tr>
            </thead>
            <tbody className="bg-[#2F2F32] text-[#BABABB]">
              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Name and surname
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect user's full name on the website during membership
                  purchasing
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  To identify the user on the territory of Hotel Services
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">Email</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect user's email during registration (iOS/Web)
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Only for user registration, authorization, and app
                  functionality. Not used for third-party services.
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Phone Number
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect user's phone number on the website during
                  membership purchasing
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  To allow hotel service managers to contact visitors
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Date of birth / age-related information
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">Gender</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect user's gender during membership purchasing
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  To provide relevant services
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Hand-drawn signature
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect user's hand-drawn signature during membership
                  purchasing
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  As an agreement to the Terms & Conditions of the Hotel Club
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Bank account details
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
                <td className="px-4 py-3 border border-[#4C4C4C]">No</td>
              </tr>

              <tr className="border-t border-[#4C4C4C]">
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  Wallet IDs (MetaMask or custodial wallets)
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  We collect the wallet ID during registration
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">
                  To identify the user, perform transactions, show token
                  balances, and display them in the profile
                </td>
                <td className="px-4 py-3 border border-[#4C4C4C]">Always</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8 mb-4">
          4. Using your personal information
        </h2>
        <p className="mb-3">
          Personal information submitted to us through our website or mobile
          application (the “App”, which includes our iOS app, Android app, and
          web-based application) will be used for the purposes specified in this
          Privacy Policy or on the relevant pages of the platform.
        </p>
        <p className="mb-3">We may use your personal information for the following purposes:</p>
        <ul className="list-disc pl-6 space-y-3 mt-2 text-[#BABABB] font-figtree font-regular leading-[16px] mb-3">
          <li>
            Administering our website, App, and overall business operations;
          </li>
          <li>Personalizing the services available to you;</li>
          <li>
            Enabling your use of the services and functionalities available
            through the App;
          </li>
          <li>
            Processing user-initiated transactions, including facilitating the
            acquisition and management of SECH tokens through integrated
            third-party services, and providing access to related features.
          </li>
          <li>Supplying services purchased through our platform;</li>
          <li>
            Sending you non-marketing communications necessary for providing
            services (such as transaction confirmations, system alerts, or
            policy updates);
          </li>
          <li>
            Sending you email notifications that you have specifically
            requested;
          </li>
          <li>
            Sending you our email newsletter, if you have opted in (you can
            unsubscribe at any time);
          </li>
          <li>
            Sending you marketing communications regarding SECH services or
            carefully selected partners’ services, provided you have explicitly
            consented to receive such communications;
          </li>
          <li>
            Providing third parties with aggregated statistical information
            about our users (in a way that does not identify any individual
            user);
          </li>
          <li>
            Dealing with inquiries, support requests, and complaints made by or
            about you relating to our services;
          </li>
          <li>
            Maintaining the security of our website, App, and associated
            services and preventing fraudulent activities;
          </li>
          <li>
            Complying with any applicable legal obligations or regulatory
            requirements.
          </li>
        </ul>
        <p className="mb-3">
          If you submit personal information for publication on our platform
          (for example, creating a user profile), we will publish and otherwise
          use that information in accordance with the permissions you grant to
          us.
        </p>
        <p className="mb-3">
          We will not, without your express consent, supply your personal
          information to any third party for their or any other third party’s
          direct marketing purposes.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8 mb-4">
          5. Disclosing personal information
        </h2>
        <p className="mb-3">
          We may disclose your personal information to any of our employees,
          officers, professional advisers, agents, suppliers, or subcontractors
          as reasonably necessary for the purposes set out in this Privacy
          Policy.
        </p>

        <p className="mb-3">We may disclose your personal information to:</p>
        <ul className="list-disc pl-6 space-y-3 mb-3 text-[#BABABB] font-figtree font-regular leading-[16px]">
          <li>
            Third-party service providers who assist us in operating our
            platform (such as payment processors, wallet providers, and
            infrastructure partners);
          </li>
          <li>
            Any member of our group of companies (this includes our
            subsidiaries, our ultimate holding company, and its subsidiaries) as
            reasonably necessary for business operations.
          </li>
        </ul>

        <p className="mb-3">We may also disclose your personal information:</p>
        <ul className="list-disc pl-6 space-y-3 mb-3 text-[#BABABB] font-figtree font-regular leading-[16px]">
          <li>To the extent required by law, regulation, or court order;</li>
          <li>
            In connection with any ongoing or prospective legal proceedings;
          </li>
          <li>
            To establish, exercise, or defend our legal rights (including
            providing information to others for the purposes of fraud prevention
            and reducing credit risk).
          </li>
        </ul>

        <p className="mb-3">
          Except as provided in this Privacy Policy, we will not disclose your
          personal information to third parties.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8">
          6. International data transfers
        </h2>
        <p className="mb-3">
          <span className="font-medium">6.1. </span>
          Information that we collect may be stored, processed, and transferred
          between any of the countries in which we operate, or where our
          third-party service providers are located, in order to enable us to
          use the information in accordance with this Privacy Policy.
        </p>
        <p className="mb-3">
          <span className="font-medium">6.2. </span>
          Personal information that you publish on our platform or submit for
          publication on our platform may be available, via the internet, around
          the world. We cannot prevent the use or misuse of such information by
          others.
        </p>
        <p className="mb-3">
          <span className="font-medium">6.3. </span>
          You expressly agree to the transfers of personal information described
          in this Section 6.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8">
          7. Retaining personal information
        </h2>
        <p className="mb-3">
          <span className="font-medium">7.1. </span>
          We will retain your personal data for as long as necessary to fulfill
          the purposes outlined in this Privacy Policy, unless a longer
          retention period is required or permitted by law. We will review the
          personal data we hold on a regular basis to determine whether we are
          still entitled to process it. If we determine that we are not entitled
          to do so, we will securely delete or anonymize the personal data,
          except where retention is necessary for compliance with legal
          obligations (such as tax, accounting, or regulatory requirements) or
          for the establishment, exercise, or defense of legal claims.
        </p>
        <p className="mb-3">
          <span className="font-medium">7.2. </span>
          We securely destroy or anonymize all personal information that is no
          longer needed for the purposes for which it was collected.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8">
          8. Security of your personal information
        </h2>
        <p className="mb-3">
          <span className="font-medium">8.1. </span>
          We take reasonable technical and organizational precautions to prevent
          the loss, misuse, or alteration of your personal information.
        </p>
        <p className="mb-3">
          <span className="font-medium">8.2. </span>
          All personal information you provide is stored on secure servers
          protected by passwords, firewalls, and other industry-standard
          security measures.
        </p>
        <p className="mb-3">
          <span className="font-medium">8.3. </span>
          You acknowledge that the transmission of information over the internet
          is inherently insecure, and we cannot guarantee the security of data
          transmitted over the internet.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Amendments</h2>
        <p className="mb-3">
          We may update this Privacy Policy from time to time by publishing a
          new version on our website and within the App. You should check this
          page periodically to ensure you are familiar with any changes.
        </p>
        <p className="mb-3">
          Where required by applicable law, we will notify you of material
          changes to this Privacy Policy and, if necessary, request your
          consent.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8">
          10. Third-party services
        </h2>
        <p className="mb-3">
          Our platform may include hyperlinks to, and details of, third-party
          websites or services.
        </p>
        <p className="mb-3">
          We have no control over, and are not responsible for, the privacy
          policies and practices of third parties.
        </p>
        <p className="mb-3">
          We encourage you to review the privacy policies of any third-party
          services you access through our platform.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mt-8">
          11. Children’s Privacy
        </h2>
        <p className="mb-3">
          We do not knowingly collect or solicit personal information from
          anyone under the age of 13.
        </p>
        <p className="mb-3">
          If we become aware that we have collected personal information from a
          child under 13 without parental consent, we will take steps to delete
          such information promptly.
        </p>
        <p className="mb-3">
          If you believe that we might have any information from or about a
          child under 13, please contact us at{' '}
          privacy@sech.io
        </p>
      </section>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
